import type { Rect } from "../types/C1_AppTypes";
import type { WallSide } from "../types/C1_ModelTypes";
import type { C1_Floor } from "./C1_Floor";
import type { C1_Project } from "./C1_Project";
import type { C1_Room } from "./C1_Room";

/**
 * Moves a room edge and the explicitly linked wall segments of adjacent rooms.
 */
export function resizeRoomEdge({
  floor,
  project,
  room,
  side,
  segmentStart,
  segmentEnd,
  nextRect,
  snappingDisabled = false,
  preserveExactSize = false,
}: {
  floor: C1_Floor;
  project: C1_Project;
  room: C1_Room;
  side: WallSide;
  segmentStart: number;
  segmentEnd: number;
  nextRect: Rect;
  snappingDisabled?: boolean;
  preserveExactSize?: boolean;
}) {
  void floor;
  void side;
  void segmentStart;
  void segmentEnd;
  // setRect moves only the outer polygon vertices and their linked neighbors.
  room.setRect(nextRect, project, snappingDisabled, preserveExactSize);
}
